import { JsonObject } from '@/lib/helpers';
import { AwsPrivateModelConfig, AwsPrivateModelModel } from './aws-private-model.model';
import { PrivateModelModel } from './private-model.model';
import { cloneDeep } from 'lodash';
import {
  AzureOpenAIPrivateModelConfig,
  AzureOpenAIPrivateModelModel,
} from './azure-openai-private-model.model';
import { VertexPrivateModelConfig, VertexPrivateModelModel } from './vertex-private-model.model';

export type PrivateModelProvider =
  | 'bedrock'
  | 'openai'
  | 'azure'
  | 'gemini'
  | 'perplexity'
  | 'nvidia_nim'
  | 'azure_ai'
  | 'vertex_ai'
  | 'anthropic'
  | 'cloudflare';

export type PrivateModelConfig =
  | AwsPrivateModelConfig
  | AzureOpenAIPrivateModelConfig
  | VertexPrivateModelConfig;

export const PrivateModelMap: Map<PrivateModelProvider, PrivateModelModel> = new Map();

PrivateModelMap.set('bedrock', new AwsPrivateModelModel());
PrivateModelMap.set('azure', new AzureOpenAIPrivateModelModel());
PrivateModelMap.set('vertex_ai', new VertexPrivateModelModel());

export const getTypedPrivateModel = (model: PrivateModelModel) => {
  const typedModel = PrivateModelMap.get(model.provider);

  if (!typedModel) {
    return model;
  }

  const Constructor = typedModel.constructor as new (data?: JsonObject) => typeof typedModel;

  const config = {
    ...typedModel.config,
    ...model.config,
  };

  const data = cloneDeep({ ...model._props, config });

  return new Constructor(data)!;
};
